import React from "react";
import toast from "react-hot-toast";
import { AlertBase, AlertCloseButton, AlertContent, Text } from "@compono/ui";
import { CheckCircleSolidIcon, CloseCircleSolidIcon } from "@compono/ui-icons";

const toastStyles = {
  display: "block",
  padding: 0,
  maxWidth: "min-content",
  boxShadow: "none",
  background: "transparent",
};

type AlertType = "success" | "error";

export const showAlert = ({
  title,
  content,
  cto,
  alertType = "success",
}: {
  title: string;
  content: string;
  cto?: string;
  alertType?: AlertType;
}) => {
  const icon =
    alertType === "success" ? CheckCircleSolidIcon : CloseCircleSolidIcon;
  const tone = alertType === "success" ? "success" : "critical";

  toast(
    (t) => (
      <AlertBase
        sx={{ position: "relative" }}
        tone={tone}
        size="md"
        icon={icon}
      >
        <AlertCloseButton
          onClick={() => {
            toast.dismiss(t.id);
          }}
        />
        <AlertContent title={title}>
          <Text>{content}</Text>
        </AlertContent>
      </AlertBase>
    ),
    {
      duration: 5000,
      position: "top-center",
      style: toastStyles,
    }
  );
  window.scrollTo({ top: 0, behavior: "smooth" });
};
